import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-8d2e56ec"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "flex-between"
};
const _hoisted_2 = {
  key: 0
};
const _hoisted_3 = {
  key: 1
};
const _hoisted_4 = {
  key: 2
};
const _hoisted_5 = {
  key: 6,
  style: {
    "display": "flex",
    "width": "220px"
  }
};
const _hoisted_6 = {
  key: 0
};
const _hoisted_7 = {
  key: 1
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "至", -1));
const _hoisted_9 = {
  key: 0
};
const _hoisted_10 = {
  key: 1
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_input = _resolveComponent("el-input");
  const _component_Search = _resolveComponent("Search");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_Operation = _resolveComponent("Operation");
  const _component_el_divider = _resolveComponent("el-divider");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_popover = _resolveComponent("el-popover");
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  const _component_el_date_picker = _resolveComponent("el-date-picker");
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_form = _resolveComponent("el-form");
  const _directive_loading = _resolveDirective("loading");
  return _openBlock(), _createBlock(_component_el_form, {
    ref: "form",
    inline: $props.inline,
    model: $data.form,
    rules: $props.baseRules
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.properties, (item, index) => {
      return _openBlock(), _createBlock(_component_el_form_item, {
        key: index,
        label: item.label,
        prop: item.prop,
        "label-width": item.label === '最新轨迹停留时长(天)' ? '150px' : $props.width
      }, {
        default: _withCtx(() => [item.type === 'input' && !item.range && item.prop !== 'waybill_no' ? (_openBlock(), _createBlock(_component_el_input, {
          key: 0,
          modelValue: $data.form[item.prop],
          "onUpdate:modelValue": $event => $data.form[item.prop] = $event,
          placeholder: "请输入内容",
          clearable: ""
        }, null, 8, ["modelValue", "onUpdate:modelValue"])) : _createCommentVNode("", true), item.type === 'input' && item.prop === 'waybill_no' ? (_openBlock(), _createBlock(_component_el_input, {
          key: 1,
          modelValue: $data.form[item.prop],
          "onUpdate:modelValue": $event => $data.form[item.prop] = $event,
          placeholder: "请输入内容",
          clearable: "",
          style: {
            "width": "242px !important"
          }
        }, {
          append: _withCtx(() => [_createVNode(_component_el_icon, {
            class: "el-icon-search search-btn",
            onClick: $event => $options.searchWaybillNo(1, item.prop)
          }, {
            default: _withCtx(() => [_createVNode(_component_Search)]),
            _: 2
          }, 1032, ["onClick"]), _createVNode(_component_el_popover, {
            width: 400,
            visible: $data.popoverVisible
          }, {
            reference: _withCtx(() => [_createVNode(_component_el_icon, {
              class: "search-btn",
              color: $data.operationIconColor,
              onClick: _cache[0] || (_cache[0] = $event => $options.changePopoverState(true, '#409eff'))
            }, {
              default: _withCtx(() => [_createVNode(_component_Operation)]),
              _: 1
            }, 8, ["color"])]),
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: $data.form['multiple_waybill_no'],
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.form['multiple_waybill_no'] = $event),
              placeholder: "请输入内容",
              type: "textarea",
              rows: 10
            }, null, 8, ["modelValue"]), _createVNode(_component_el_divider), _createElementVNode("div", _hoisted_1, [_createVNode(_component_el_button, {
              size: "small",
              onClick: $options.clearMultipleWaybillNo
            }, {
              default: _withCtx(() => [_createTextVNode(" 清空 ")]),
              _: 1
            }, 8, ["onClick"]), _createElementVNode("div", null, [_createVNode(_component_el_button, {
              size: "small",
              onClick: _cache[2] || (_cache[2] = $event => $options.changePopoverState(false, 'inherit'))
            }, {
              default: _withCtx(() => [_createTextVNode(" 关闭 ")]),
              _: 1
            }), _createVNode(_component_el_button, {
              size: "small",
              onClick: _cache[3] || (_cache[3] = $event => $options.searchWaybillNo(2, 'multiple_waybill_no'))
            }, {
              default: _withCtx(() => [_createTextVNode(" 搜索 ")]),
              _: 1
            })])])]),
            _: 1
          }, 8, ["visible"])]),
          _: 2
        }, 1032, ["modelValue", "onUpdate:modelValue"])) : _createCommentVNode("", true), (item.type === 'select' || item.type === 'remote') && !item.range ? (_openBlock(), _createBlock(_component_el_select, {
          key: 2,
          modelValue: $data.form[item.prop],
          "onUpdate:modelValue": $event => $data.form[item.prop] = $event,
          clearable: "",
          filterable: "",
          placeholder: item.placeholder ? item.placeholder : '请选择',
          remote: item.type === 'remote',
          "reserve-keyword": item.type === 'remote',
          loading: item.type === 'remote' ? $data.remoteLoading : false,
          multiple: item.multiple,
          "collapse-tags": item.multiple,
          "collapse-tags-tooltip": item.multiple,
          "remote-method": str => $options.remoteMethod(str, item.prop, item.type),
          style: _normalizeStyle(item.prop === 'shipping_time_unit' || item.prop === 'year' ? 'width: 90px !important' : ''),
          disabled: $options.disabled(item.prop, item.disabled),
          onChange: val => $options.getRelatedInfo(val, item.multiple, item.prop, item.type)
        }, {
          default: _withCtx(() => [_withDirectives((_openBlock(), _createElementBlock("div", null, [item.option_type === 'name' ? (_openBlock(), _createElementBlock("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.options, option => {
            return _openBlock(), _createBlock(_component_el_option, {
              key: option.id,
              label: option.name,
              value: option.id
            }, null, 8, ["label", "value"]);
          }), 128))])) : item.option_type === 'other' ? (_openBlock(), _createElementBlock("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.options, option => {
            return _openBlock(), _createBlock(_component_el_option, {
              key: option.key,
              label: option.value,
              value: option.key
            }, null, 8, ["label", "value"]);
          }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.options, option => {
            return _openBlock(), _createBlock(_component_el_option, {
              key: option.id,
              label: option.order_no,
              value: option.id
            }, null, 8, ["label", "value"]);
          }), 128))]))])), [[_directive_loading, $data.optionLoading]])]),
          _: 2
        }, 1032, ["modelValue", "onUpdate:modelValue", "placeholder", "remote", "reserve-keyword", "loading", "multiple", "collapse-tags", "collapse-tags-tooltip", "remote-method", "style", "disabled", "onChange"])) : _createCommentVNode("", true), item.type === 'single-date' && !item.range ? (_openBlock(), _createBlock(_component_el_date_picker, {
          key: 3,
          modelValue: $data.form[item.prop],
          "onUpdate:modelValue": $event => $data.form[item.prop] = $event,
          type: "datetime",
          placeholder: "请选择支付时间"
        }, null, 8, ["modelValue", "onUpdate:modelValue"])) : _createCommentVNode("", true), item.type === 'date' && !item.range ? (_openBlock(), _createBlock(_component_el_date_picker, {
          key: 4,
          modelValue: $data.form[item.prop],
          "onUpdate:modelValue": $event => $data.form[item.prop] = $event,
          type: "daterange",
          "start-placeholder": "年-月-日",
          "end-placeholder": "年-月-日",
          onChange: val => $options.changeDate(val, item.prop)
        }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])) : _createCommentVNode("", true), item.type === 'textarea' && !item.range ? (_openBlock(), _createBlock(_component_el_input, {
          key: 5,
          modelValue: $data.form[item.prop],
          "onUpdate:modelValue": $event => $data.form[item.prop] = $event,
          type: "textarea",
          placeholder: "请输入内容",
          clearable: ""
        }, null, 8, ["modelValue", "onUpdate:modelValue"])) : _createCommentVNode("", true), item.range ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(_component_el_col, {
          span: 10
        }, {
          default: _withCtx(() => [item.type === 'input' ? (_openBlock(), _createBlock(_component_el_input, {
            key: 0,
            modelValue: $data.form[item.prop1],
            "onUpdate:modelValue": $event => $data.form[item.prop1] = $event,
            placeholder: "请输入",
            style: {
              "width": "90px !important"
            },
            onInput: $event => $options.checkStayTime($data.form[item.prop1])
          }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput"])) : _createCommentVNode("", true), item.type === 'select' ? (_openBlock(), _createBlock(_component_el_select, {
            key: 1,
            modelValue: $data.form[item.prop1],
            "onUpdate:modelValue": $event => $data.form[item.prop1] = $event,
            placeholder: "请选择",
            clearable: "",
            style: {
              "width": "90px !important"
            }
          }, {
            default: _withCtx(() => [$data.form.shipping_time_unit !== 'y' ? (_openBlock(), _createElementBlock("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.option, i => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: i,
                label: i,
                value: i
              }, null, 8, ["label", "value"]);
            }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.option, i => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: i.key,
                label: i.value,
                value: i.key
              }, null, 8, ["label", "value"]);
            }), 128))]))]),
            _: 2
          }, 1032, ["modelValue", "onUpdate:modelValue"])) : _createCommentVNode("", true)]),
          _: 2
        }, 1024), _createVNode(_component_el_col, {
          span: 4,
          style: {
            "text-align": "center"
          }
        }, {
          default: _withCtx(() => [_hoisted_8]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 10
        }, {
          default: _withCtx(() => [item.type === 'input' ? (_openBlock(), _createBlock(_component_el_input, {
            key: 0,
            modelValue: $data.form[item.prop2],
            "onUpdate:modelValue": $event => $data.form[item.prop2] = $event,
            placeholder: "请输入",
            style: {
              "width": "90px !important"
            },
            onInput: $event => $options.checkStayTime($data.form[item.prop2])
          }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput"])) : _createCommentVNode("", true), item.type === 'select' ? (_openBlock(), _createBlock(_component_el_select, {
            key: 1,
            modelValue: $data.form[item.prop2],
            "onUpdate:modelValue": $event => $data.form[item.prop2] = $event,
            placeholder: "请选择",
            clearable: "",
            style: {
              "width": "90px !important"
            }
          }, {
            default: _withCtx(() => [$data.form.shipping_time_unit !== 'y' ? (_openBlock(), _createElementBlock("div", _hoisted_9, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.option, i => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: i,
                label: i,
                value: i
              }, null, 8, ["label", "value"]);
            }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_10, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.option, i => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: i.value,
                label: i.value,
                value: i.value
              }, null, 8, ["label", "value"]);
            }), 128))]))]),
            _: 2
          }, 1032, ["modelValue", "onUpdate:modelValue"])) : _createCommentVNode("", true)]),
          _: 2
        }, 1024)])) : _createCommentVNode("", true)]),
        _: 2
      }, 1032, ["label", "prop", "label-width"]);
    }), 128)), _createVNode(_component_el_form_item, {
      class: "btn-position"
    }, {
      default: _withCtx(() => [_renderSlot(_ctx.$slots, "default", {}, undefined, true)]),
      _: 3
    })]),
    _: 3
  }, 8, ["inline", "model", "rules"]);
}